import Reveal from '@/components/base/Reveal';
import { improvements } from '@/mocks/results';

export default function WhatChanged() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="w-[520px] h-[520px] rounded-full bg-primary-500/6 blur-[130px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Behind the Results
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Growth Usually Comes From Fixing the Whole System.
          </h2>
          <p className="mt-4 text-foreground-600">
            Real results are rarely just &ldquo;better ads.&rdquo; They come from improving the
            connected parts of the marketing system together.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {improvements.map((item, i) => (
            <Reveal key={item.title} delay={(i % 3) * 80}>
              <div className="h-full rounded-xl border border-white/8 bg-background-100 p-6 hover:border-primary-500/30 transition-colors">
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <span className="text-xs font-label font-semibold text-foreground-600">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="mt-5 font-heading font-semibold text-base text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}